/// <amd-module name="SuiteCommerce.LookBook.Look.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.Look.View", ["require", "exports", "suitecommerce_lookbook_look.tpl", "SuiteCommerce.LookBook.Common.Configuration", "Backbone", "SuiteCommerce.LookBook.LookItem.CollectionView", "SuiteCommerce.LookBook.Instrumentation", "jQuery", "BxSlider"], function (require, exports, lookTpl, Configuration_1, Backbone_1, LookItem_CollectionView_1, Instrumentation_1, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookView = void 0;
    var LookView = /** @class */ (function (_super) {
        __extends(LookView, _super);
        function LookView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = lookTpl;
            _this.title = '';
            _this.metaKeywords = '';
            _this.metaDescription = '';
            _this.model = options.model;
            _this.title = _this.model.getTitle();
            _this.metaKeywords = _this.model.getMetaKeywords();
            _this.metaDescription = _this.model.getMetaDescription();
            _this.setupListeners();
            return _this;
        }
        LookView.prototype.setupListeners = function () {
            var _this = this;
            this.on('afterViewRender', function () {
                _this.slider = _this.$('[data-slider]').bxSliderNew({
                    nextText: '<a class="lookbook-gallery-next-icon"></a>',
                    prevText: '<a class="lookbook-gallery-prev-icon"></a>',
                    touchEnabled: true,
                    auto: true,
                    pager: true,
                });
                jQuery(function () {
                    _this.reloadSlider();
                });
            });
        };
        LookView.prototype.reloadSlider = function () {
            if (this.slider && this.slider.length > 0) {
                this.slider.reloadSlider();
            }
        };
        LookView.prototype.getBreadcrumbPages = function () {
            return [
                {
                    text: this.model.getLookbok(),
                    href: '/lookbook/' + this.model.getLookBookUrlComponent(),
                },
                {
                    text: this.model.getName(),
                    href: '/' + this.model.getUrlComponent(),
                },
            ];
        };
        Object.defineProperty(LookView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'LookBook.LookItems': function () {
                        return new LookItem_CollectionView_1.LookItemCollectionView({
                            collection: _this.model.getItems(),
                        });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        LookView.prototype.logShowSpecificLook = function () {
            if (this.model.getItems().length > 0) {
                var logUsage = Instrumentation_1.default.getLog('Show landing page of look specific');
                logUsage.setParameters({
                    activity: 'Show landing page of look specific',
                    instanceCount: this.model.getItems().length
                });
                logUsage.submit();
            }
        };
        LookView.prototype.getContext = function () {
            return {
                subtitle: Configuration_1.Configuration.lookSubtitle,
                detailsTitle: Configuration_1.Configuration.lookDetailsTitle,
                name: this.model.getName(),
                sequence: this.model.getSequence(),
                urlcomponent: this.model.getUrlComponent(),
                shortdesc: this.model.getShortDesc(),
                longdesc: this.model.getLongDesc(),
                mainimage: this.model.getMainImage(),
                altimage: this.model.getAltImage(),
                lookbook: this.model.getLookbok(),
            };
        };
        return LookView;
    }(Backbone_1.View));
    exports.LookView = LookView;
});
